// extracted by mini-css-extract-plugin
module.exports = {"w-result":"bet-history_w-result__2Vlfr"};